var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ui-stage',[_c('AdminList',{attrs:{"apiPrefix":`/api/v3/${_setup.modulePath}`,"module":_setup.modulePath}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }